<div class="d-flex align-items-center flex-direction-col no-results alert alert-warning"><ng-content></ng-content></div>
